import Link from 'next/link';
import { cn } from '@/lib/utils';

export function Footer({ className }: { className?: string }) {
  return (
    <footer className={cn('border-t border-surface-3 bg-surface-2', className)}>
      <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-tertiary text-xs">
          <span className="font-serif font-bold text-cream/60">FantasyPRIME</span>{' '}
          &copy; 2026
        </p>
        <nav className="flex items-center gap-4 text-xs text-tertiary">
          <Link href="/faq" className="hover:text-gold transition-colors">
            FAQ
          </Link>
          <Link href="/privacy" className="hover:text-gold transition-colors">
            Privacy Policy
          </Link>
          <Link href="/terms" className="hover:text-gold transition-colors">
            Terms of Service
          </Link>
        </nav>
      </div>
    </footer>
  );
}
